// @flow

import React from 'react';
import classNames from 'classnames';

import style from './UiSection.module.css';

type PropsType = {
  styleMod: string,
  pdMod: string,
  styleClassName: string,
  children: any
};

function UiSection({ styleMod, pdMod = null, children, styleClassName }: PropsType) {
  return (
    <section
      className={classNames(style.section, style[`mod-${styleMod}`], style[`mod-${pdMod}-pd`], style[styleClassName])}
    >
      <div className="fix">{children}</div>
    </section>
  );
}

export default UiSection;
